import { z } from 'zod';
import { ReviewDTO } from './ReviewDTO';

export const RatingsAndReviewsDTO = z.object({
    count: z.number(),
    filters: z.array(
        z.object({
            id: z.string(),
            type: z.string(),
            refinements: z
                .array(
                    z.object({
                        id: z.string(), // FIXME: should be optional/nullable according to the API documentation
                        count: z.number(), // FIXME: should be optional/nullable according to the API documentation
                    }),
                )
                .default([]),
        }),
    ),
    // FIXME: should be optional/nullable according to the API documentation
    sorting: z.array(
        z.object({
            id: z.string(),
            label: z.string(),
        }),
    ),
    // FIXME: should be optional/nullable according to the API documentation
    reviews: z.array(ReviewDTO),
    distribution: z
        .array(
            z.object({
                rating: z.number(), // FIXME: should be optional/nullable according to the API documentation
                count: z.number(), // FIXME: should be optional/nullable according to the API documentation
            }),
        )
        .default([]),
});

export type RatingsAndReviewsDTO = z.infer<typeof RatingsAndReviewsDTO>;
